import { CookiesStorageService } from '@/services/cookiesStorageService';
import { LANDING_COOKIE_STORAGE } from '@/constants';
import { decodeJwtPayload, isJwtExpired } from './isJwtExpired';

/**
 * Email of the landing's funnel user, or `null` while they are still anonymous.
 *
 * The token is written by the email flow (see `useEmailFunnelFlow`), so this is
 * how a page tells whether the visitor has already been patched and can skip
 * the email popup.
 *
 * Client-side only — the token lives in a cookie, so callers must read it after
 * mount to keep SSR markup (and the CDN cache) user-agnostic.
 */
export function getLandingUserEmail(): string | null {
	const token = CookiesStorageService.get<string>(
		LANDING_COOKIE_STORAGE.AUTH_TOKEN,
		'',
	);
	if (!token || isJwtExpired(token)) return null;

	const payload = decodeJwtPayload<{ email?: string | null }>(token);
	return payload?.email || null;
}
